<template>
  <div class="view-container">
    <div class="image-view">
      <cropper
        class="cropper"
        :src="imageSrc"
        @change="onCropChange"
        :stencilProps="{
          minAspectRatio: 2 / 5,
          maxAspectRatio: 5 / 2
        }"
        :defaultPosition="{left: 0, top: 0}"
        :defaultSize="{width: imageSize.width, height: imageSize.height}"
      />
      <div class="ratio-selection-bar">
        <p style="font-size: 24px; color: #999;">{{imageFileName}}</p>
      </div>
    </div>
    <div class="selector-container">
      <div class="selector-align-field">
        <p v-if="lang=='en'" class="title-text">Mood selection</p>
        <p v-if="lang=='ko'" class="title-text">무드 선택하기</p>
        <MoodSelector
          :lang="lang"
          @selection="receiveSelectedMood"
        />
        <div class="sized-box-height-30px"></div>
        <b-button
          class="generate-btn"
          block
          size="lg"
          variant="primary"
          @click="onGenerate"
          style="font-size: 44px; width: 380px;"
        >
          {{ lang === 'en' ? 'Generate Video' : '비디오 생성하기' }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import MoodSelector from '../components/MoodSelector.vue'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';

export default {
  name: 'MoodSelectionPageView',
  
  components: {
    MoodSelector
    ,Cropper
  },

  props: {
    lang: {
      type: String,
      required: true
    },
    imageSrc: {
      type: String,
      required: true
    },
    imageSize: {
      type: Object,
      required: true
    },
    imageFileName: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      canvas: null
      ,selectedMood: {}
    }
  },

  methods: {
    async onGenerate() {
      if (!this.selectedMood.mood) {
        await this.$bvModal.msgBoxOk(
          this.lang === 'en' ? 'You have to select the mood!' : '무드를 선택하세요!',
          {
            title: 'Warning',
            size: 'lg',
            buttonSize: 'lg',
            okVariant: 'success',
            centered: true
          }
        ).catch(e => console.log("Error while radio selection filtering: " + e.message))
        return
      }
      this.canvas.toBlob((blob) => {
        let file = new File([blob], 'image.jpeg', {type: 'image/jpeg'})
        // console.log(file)
        this.$emit('generate', {canvasFile: file, moodData: this.selectedMood})
      }, 'image/jpeg')
      
    }
    ,onCropChange({coordinates, canvas}) {
      console.log(coordinates, canvas)
      console.log(canvas.toBlob((blob) => {
        let file = new File([blob], 'image.jpeg', {type: 'image/jpeg'})
        console.log(file)
      }, 'image/jpeg'))
      // console.log(canvas.toDataURL()) // base64 encoded image
      this.canvas = canvas
    }
    ,receiveSelectedMood(moodObject) {
      this.selectedMood = moodObject
      console.log("received emit: "+this.selectedMood.mood)
    }
  },

}
</script>

<style scoped>
.view-container {
  display: flex;
  flex-direction: row;
}
.image-view {
  display: block;
  width: 1100px;
}
.selector-container {
  display: block;
  width: 500px;
}
.selector-align-field {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.cropper {
  max-width: 900px;
  max-height: 500px;
  margin: 0 auto;
  background: #DDD;
}
/* .ratio-toggle-btn {
  position: absolute;
  top: 310px;
  left: 0px;
} */
.ratio-selection-bar {
  margin: 5px 86.65625px 5px 0px; /* 추가, 위아래만 5 */
  display: grid;
  grid-template-columns: auto auto;
}
.ratio-selection-bar > button {
  font-size: 24px;
  width: 180px;
}
.sized-box-height-30px {
  display: block;
  height: 30px;
}
</style>
